import { articleImages } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function BlogPreviewSection() {
  const articles = [
    {
      slug: "oopbuy-spreadsheet-complete-guide-2026",
      title: "OOPBuy Spreadsheet Complete Guide 2026",
      excerpt: "Everything you need to know about getting started with spreadsheet-based shopping in 2026.",
      image: articleImages.guide,
      tag: "Beginner Guide",
    },
    {
      slug: "oopbuy-spreadsheet-tips-and-tricks",
      title: "Advanced OOPBuy Spreadsheet Tips & Tricks",
      excerpt: "Master the art of efficient product comparison with these expert spreadsheet strategies.",
      image: articleImages.tips,
      tag: "Advanced",
    },
    {
      slug: "oopbuy-vs-panda-spreadsheet-comparison",
      title: "OOPBuy vs Panda Spreadsheet Comparison",
      excerpt: "A detailed head-to-head comparison of the leading spreadsheet shopping platforms.",
      image: articleImages.compare,
      tag: "Comparison",
    },
    {
      slug: "oopbuy-spreadsheet-safety-and-security",
      title: "OOPBuy Spreadsheet Safety & Security Guide",
      excerpt: "Learn how spreadsheet-based shopping keeps your data secure and private.",
      image: articleImages.safety,
      tag: "Safety",
    },
    {
      slug: "oopbuy-spreadsheet-system-overview",
      title: "OOPBuy Spreadsheet System Architecture Explained",
      excerpt: "Deep dive into how the OOPBuy spreadsheet engine organizes and structures product data.",
      image: articleImages.a1,
      tag: "System Design",
    },
    {
      slug: "oopbuy-spreadsheet-price-comparison",
      title: "Ultimate OOPBuy Price Comparison Strategy",
      excerpt: "Learn proven techniques to find the best deals using OOPBuy spreadsheet price analysis.",
      image: articleImages.a2,
      tag: "Price Guide",
    },
    {
      slug: "oopbuy-spreadsheet-mobile-guide",
      title: "OOPBuy Spreadsheet on Mobile: Full Guide",
      excerpt: "How to use OOPBuy spreadsheet shopping tools on your smartphone and tablet devices.",
      image: articleImages.a3,
      tag: "Mobile",
    },
    {
      slug: "oopbuy-spreadsheet-time-saving",
      title: "Save Hours with OOPBuy Spreadsheet Shortcuts",
      excerpt: "Time-saving techniques that experienced OOPBuy users rely on for faster product discovery.",
      image: articleImages.a4,
      tag: "Productivity",
    },
    {
      slug: "oopbuy-spreadsheet-category-breakdown",
      title: "Complete OOPBuy Category Navigation Guide",
      excerpt: "Walk through all 14 product categories and learn how to navigate them efficiently.",
      image: articleImages.a5,
      tag: "Categories",
    },
    {
      slug: "oopbuy-spreadsheet-quality-guide",
      title: "How OOPBuy Ensures Product Data Quality",
      excerpt: "Understanding the quality verification process behind every OOPBuy spreadsheet listing.",
      image: articleImages.a6,
      tag: "Quality",
    },
    {
      slug: "oopbuy-spreadsheet-budget-shopping",
      title: "Budget Shopping with OOPBuy Spreadsheet",
      excerpt: "Smart budgeting strategies combined with OOPBuy spreadsheet price tracking features.",
      image: articleImages.a7,
      tag: "Budget",
    },
    {
      slug: "oopbuy-spreadsheet-global-shopping",
      title: "OOPBuy Spreadsheet for International Shoppers",
      excerpt: "How global shoppers use OOPBuy spreadsheet tools to navigate cross-border purchasing.",
      image: articleImages.a8,
      tag: "Global",
    },
    {
      slug: "oopbuy-spreadsheet-future-trends",
      title: "Future of Spreadsheet Shopping: 2026 Trends",
      excerpt: "Explore emerging trends and innovations shaping the future of OOPBuy spreadsheet shopping.",
      image: articleImages.a9,
      tag: "Trends",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <p className="text-xs font-medium text-foreground-500 tracking-widest uppercase mb-3">
            Latest Guides
          </p>
          <h2 className="font-heading text-2xl md:text-5xl font-bold text-foreground-950 leading-tight">
            OOPBuy Spreadsheet
            <br />
            <span className="italic font-normal text-primary-500">Expert Articles</span>
          </h2>
          <p className="text-foreground-600 text-sm mt-3">
            13 in-depth guides covering everything from beginner basics to advanced strategies
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/70 px-2 py-1 rounded-md mb-3">
                  {article.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}